module.exports = __webpack_public_path__ + "static/media/Blou_6.2550ae70.png";